// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Option from "melange/option.js";

function decode_checkpoint(json) {
  return {
    id: Mapre_wire__Json.string(json, "id"),
    run_id: Mapre_wire__Json.string(json, "run_id"),
    phase: Mapre_wire__Json.string(json, "phase"),
    snapshot: Js__Js_json.decodeString(Mapre_wire__Json.get(json, "snapshot_id"))
  };
}

function decode(json) {
  const checkpoint = Caml_obj.caml_equal(Mapre_wire__Json.get(json, "checkpoint"), null) ? undefined : decode_checkpoint(Mapre_wire__Json.get(json, "checkpoint"));
  const b = Js__Js_json.decodeBoolean(Mapre_wire__Json.get(json, "can_checkpoint"));
  let eligible;
  if (b !== undefined) {
    eligible = b;
  } else {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_checkpoint_control"
      });
  }
  return {
    run_id: Js__Js_json.decodeString(Mapre_wire__Json.get(json, "run_id")),
    version: Mapre_wire__Json.integer(json, "version"),
    eligible,
    checkpoint,
    failure: Js__Js_json.decodeString(Mapre_wire__Json.get(json, "failure_code"))
  };
}

function update(t, control) {
  if (/* tag */ typeof control !== "object" && typeof control !== "function") {
    if (control === /* Uncertain */ 0) {
      return {
        control: t.control,
        attempt: Stdlib__Option.map((function (a) {
          return {
            id: a.id,
            run_id: a.run_id,
            version: a.version,
            uncertain: true
          };
        }), t.attempt),
        message: t.message
      };
    } else {
      return t;
    }
  }
  switch (control.TAG) {
    case /* Loaded */ 0 :
      const control$1 = control._0;
      const match = t.attempt;
      const match$1 = control$1.checkpoint;
      const attempt = match !== undefined && (match$1 !== undefined || Caml_obj.caml_notequal(match.run_id, control$1.run_id)) ? undefined : match;
      return {
        control: control$1,
        attempt,
        message: t.message
      };
    case /* Started */ 1 :
      return {
        control: t.control,
        attempt: control._0,
        message: ""
      };
    case /* Failed */ 2 :
      return {
        control: t.control,
        attempt: undefined,
        message: control._0
      };
  }
}

function can_submit(t) {
  if (t.attempt === undefined) {
    return Stdlib__Option.fold(false, (function (c) {
      if (c.eligible && c.checkpoint === undefined && c.failure === undefined) {
        return c.run_id !== undefined;
      } else {
        return false;
      }
    }), t.control);
  } else {
    return false;
  }
}

function child(t) {
  return Stdlib__Option.bind(Stdlib__Option.bind(t.control, (function (c) {
    return c.checkpoint;
  })), (function (cp) {
    if (cp.phase === "complete") {
      return cp.snapshot;
    }
    
  }));
}

function progress(t) {
  const cp = Stdlib__Option.bind(t.control, (function (c) {
    return c.checkpoint;
  }));
  if (cp !== undefined) {
    if (cp.phase === "complete") {
      return "Parent checkpoint ready.";
    } else if (Stdlib__Option.bind(t.control, (function (c) {
        return c.failure;
      })) !== undefined) {
      return "Checkpoint stopped: " + Stdlib__Option.get(Stdlib__Option.bind(t.control, (function (c) {
        return c.failure;
      })));
    } else {
      return "Saving parent checkpoint...";
    }
  } else if (t.attempt !== undefined) {
    return "Submitting parent checkpoint...";
  } else {
    return "Save current project files for an isolated child session. The parent sandbox will stop.";
  }
}

function body(a) {
  return JSON.stringify(Js__Js_dict.fromList({
    hd: [
      "request_id",
      Mapre_wire__Json.str(a.id)
    ],
    tl: {
      hd: [
        "run_id",
        Mapre_wire__Json.str(a.run_id)
      ],
      tl: {
        hd: [
          "expected_version",
          a.version
        ],
        tl: /* [] */ 0
      }
    }
  }));
}

const initial = {
  control: undefined,
  attempt: undefined,
  message: ""
};

export {
  initial,
  decode,
  decode_checkpoint,
  update,
  can_submit,
  child,
  progress,
  body,
}
/* Mapre_wire__Json Not a pure module */
